/** Operational manager — read-only supervisory view of managed Agents (no pay, payout, banking or Schedule A). */
import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Card, PageHeader } from '../components/finance/financeUi';

const Agent = ({ a }) => (
  <li className="space-y-2 px-5 py-4 text-sm" data-testid={`managed-agent-${a.user_id}`}>
    <p className="font-medium">{a.name} <span className="text-xs font-normal text-muted-foreground">· read-only supervision</span></p>
    <p data-testid={`managed-counts-${a.user_id}`}>{a.leads} leads · {a.opportunities_open} open opportunities · {a.opportunities_won} won · applications {Object.entries(a.applications_by_status).map(([k, v]) => `${k} ${v}`).join(', ') || 'none'}</p>
    <p className="text-xs text-muted-foreground">Volume: {a.volume_by_period.map((v) => `${v.period} $${Math.round(v.volume).toLocaleString()}`).join(' · ') || 'no processing yet'}</p>
    {a.recent_opportunities.length > 0 && <ul className="text-xs text-muted-foreground">{a.recent_opportunities.map((o, i) => <li key={o.opportunity_id || i}>{o.business_name || o.name} · {o.stage || o.status}</li>)}</ul>}
  </li>
);

export default function MyManagedAgentsPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.request('/economic-relationships/my-managed').then(setRows).catch(() => setRows([])); }, []);
  return (
    <div className="space-y-6" data-testid="my-managed-agents-page">
      <PageHeader title="My Managed Agents" subtitle="Agents MSC has asked you to supervise. You can see their activity and production; their pay and payouts stay between them and MSC." />
      <Card title="Managed Agents" testid="managed-agents-card">
        {rows && !rows.length && <p className="px-5 py-6 text-sm text-muted-foreground" data-testid="managed-empty">MSC hasn't assigned you any Agents to manage.</p>}
        <ul className="divide-y">{(rows || []).map((a) => <Agent key={a.user_id} a={a} />)}</ul>
      </Card>
    </div>
  );
}
